import { ALL_THEMES } from 'lib/context/ThemeContext';
import { tv } from 'tailwind-variants';

const themeVariants = ALL_THEMES.reduce(
  (acc, curr) => ((acc[curr] = {}), acc),
  {} as Record<string, object>
);

export const tailwindVariants = tv({
  slots: {
    base: ['component', 'pullQuote', 'relative'],
    container: ['mx-auto', 'max-w-screen-xl'],
    contentCarousel: [
      'flex-1',
      'flex-col',
      'flex',
      'max-lg:px-0',
      'max-lg:py-0',
      'order-2',
      'lg:order-1',
    ],
    contentCarouselTrack: [
      'mb-components-pull-quote-spacing-small-quote-margin-bottom',
      'md:mb-components-pull-quote-spacing-large-quote-margin-bottom',
    ],
    controlContainerClasses: [
      'flex',
      'gap-6',
      'lg:px-components-hero-homepage-spacing-large-padding-x',
      'justify-end',
      'items-center',
    ],
    iconNext: ['chevron_right'],
    iconPrev: ['chevron_left'],
    playPauseFill: ['fill-components-button-color-outline-white-default-icon'],
    pullQuoteItemWrapper: ['flex', 'flex-row', 'justify-center', 'md:w-auto', 'h-full'],
    pullQuoteSingleItem: [
      'flex',
      'flex-row',
      'justify-center',
      'w-auto',
      'md:max-w-[770px]',
      'm-auto',
    ],
    pullQuoteWrapper: [
      'bg-components-pull-quote-color-bg',
      'py-themes-general-surface-spacing-small-padding-y',
      'px-themes-general-surface-spacing-small-padding-x',
      'md:py-themes-general-surface-spacing-large-padding-y',
      'md:px-themes-general-surface-spacing-large-padding-x',
    ],
    topSVGclasses: ['absolute', 'hidden', 'md:block', 'top-0', 'left-0', 'w-full'],
    bottomSVGclasses: ['absolute', 'hidden', 'md:block', 'bottom-0', 'left-0', 'w-full'],
  },
  variants: {
    brand: {
      ...themeVariants,
      Off: {
        pullQuoteWrapper: [
          'md:bg-auto',
          'md:bg-no-repeat',
          'md:bg-[url("/assets/Pull-Quote/decor,Brand=Off.svg")]',
          'md:bg-[left_85px]',
        ],
      },
      Autan: {
        pullQuoteWrapper: [
          'md:bg-auto',
          'md:bg-no-repeat',
          'md:bg-[url("/assets/Pull-Quote/decor,Brand=Autan.svg")]',
          'md:bg-[left_85px]',
        ],
      },
      OffDefense: {
        pullQuoteWrapper: [
          'md:bg-auto',
          'md:bg-no-repeat',
          'md:bg-[url("/assets/Pull-Quote/decor,Brand=OffDefense.svg")]',
          'md:bg-[left_85px]',
        ],
      },
      Raid: {
        pullQuoteWrapper: [
          'md:bg-auto',
          'md:bg-no-repeat',
          'md:h-full',
          'bg-[url("/assets/Pull-Quote/decor,Brand=Raid.svg")]',
        ],
      },
      Duck: {
        pullQuoteWrapper: [
          'md:bg-auto',
          'md:bg-no-repeat',
          'md:h-full',
          'bg-[url("/assets/Pull-Quote/decor,Brand=Duck.svg")]',
        ],
      },
    },
  },
});
